import { render, staticRenderFns } from "./SAPK_rwpangkat_Modal.vue?vue&type=template&id=6e4c997a"
import script from "./SAPK_rwpangkat_Modal.vue?vue&type=script&lang=js"
export * from "./SAPK_rwpangkat_Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports